const passengers = {
  table: {
    headers: {
      supplier: 'צי',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'צי',
        fields: {
          label: 'צי מועדף',
        },
      },
    },
  },
};

export default passengers;
